import currency from 'currency.js'

export const toBarChartData = data => {
  if (!data) return {}
  if (Array.isArray(data)) return null

  let totalCount = 0
  let totalBidValue = 0
  let totalWonValue = 0
  const keys = ['Won', 'Bid', 'Cost', 'Profit']
  const barByValue = Object.keys(data).reduce((a, item) => {
    const elem = data[item]
    totalBidValue += elem.totalBidValue
    totalWonValue += elem.totalWonValue
    totalCount += elem.count
    a.push({
      month: item,
      Won: currency(elem.totalWonValue).value,
      Bid: currency(elem.totalBidValue).value,
      Cost: currency(elem.totalCostValue).value,
      Profit: currency(elem.totalProfitValue).value
    })

    return a
  }, [])

  return {
    keys,
    barByValue,
    totalCount,
    totalBidValue,
    totalWonValue
  }
}

export const toUsers = users =>
  users.map(user => ({
    value: user.id,
    label: user.userName
  }))

export const getColors = bar => {
  const colors = { Won: '#92D050', Bid: '#595959', Cost: '#007BFF', Profit: '#3CB371' }
  return colors[bar.id]
}

export const toYears = years => {
  return years.map(year => ({
    value: year,
    label: year
  }))
}
